module.exports = __webpack_public_path__ + "c7bbaae75ce4123b9ca21c2ae20421b0.svg";